/* global NetworkConfig, DefaultLogoSize */
import PropTypes from 'prop-types';
import { getNetworkLogoUrl } from 'helpers/ContentHelper';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import { NETWORK_LOGO_IMAGE, renderImage } from 'helpers/ImageHelper';

const DEFAULT_IMAGE_SIZE = DefaultLogoSize || 50;

const BREAKPOINTS = breakpoint => {
  switch (breakpoint) {
    case SITE_PLATFORM_WEB_LARGE:
    case SITE_PLATFORM_WEB:
      return 'desktop';
    case SITE_PLATFORM_TABLET:
    case SITE_PLATFORM_MOBILE:
      return 'mobile';
    default:
      return 'desktop';
  }
};

const NetworkImage = (props = {}) => {
  const getTitle = () => {
    const { network, title } = props;
    const { branding, name } = NetworkConfig;
    if (title) return title;
    if (network === branding) return name;
    return network;
  };

  const getNetworkLogoUrlFromConfig = () => {
    const { breakpoint } = props;
    const { appLogo } = window.ExternalConfig;
    if (!appLogo) return null;
    if (typeof appLogo === 'string') return appLogo;

    const appLogoPath = BREAKPOINTS(breakpoint);
    const logo = appLogo[appLogoPath] || null;
    return logo;
  };

  const getUrl = (network, size) => {
    const { extended } = props;
    const { extendedNetworkLogo } = window.ExternalConfig;
    if (extended) {
      return getNetworkLogoUrl(network, size, extendedNetworkLogo);
    }
    return getNetworkLogoUrlFromConfig();
  };

  const { breakpoint, network, size, alt, url, lazyLoad = true } = props;
  const src = url || getUrl(network, size);
  const altText = alt || `${network} logo`;
  const title = getTitle();
  return renderImage({
    alt: altText,
    breakpoint,
    imageType: NETWORK_LOGO_IMAGE,
    lazyLoad,
    src,
    title,
  });
};

NetworkImage.defaultProps = {
  network: NetworkConfig.branding,
  size: DEFAULT_IMAGE_SIZE,
  title: null,
  alt: null,
  url: null,
  extended: false,
};

NetworkImage.propTypes = {
  network: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.number,
  extended: PropTypes.bool,
  breakpoint: PropTypes.string.isRequired,
  lazyLoad: PropTypes.bool,
};

export default NetworkImage;
